import React from "react";

import { Preview } from "@creatomate/preview";
import { Badge, classnames, Icon, PlainButton } from "@culturehq/components";

import { Audio } from "chq";
import { useExpand } from "app/hooks";
import { getDuration, Trans } from "app/utils";

import Waveform from "components/common/Waveform";
import { addAudio } from "components/stories/video-studio/utils";

interface AudioOptionProps {
  audio: Audio;
  isPlaying: boolean;
  onPlay: () => void;
  preview: Preview;
}

const AudioOption: React.FC<AudioOptionProps> = ({ audio, isPlaying, onPlay, preview }) => {
  const numberOfTagsToshow = 3;
  const [expanded, onExpand] = useExpand();

  const handleAddAudio = async () => {
    addAudio(preview, 0, audio.url, audio);
  };

  return (
    <>
      <div className={classnames("Stories-Audios__Audio")}>
        <div className="Stories-Audios__Audio--Media">
          <div className="Stories-Audios__Audio--Thumbnail">
            <div className="Audio--Image" style={{ backgroundImage: `url(${audio.imageUrl})` }} />
            <div className="Audio--Image Audio--Image__Overlay" />
            <span className="Audio--Duration">{getDuration(audio.duration)}</span>
          </div>
          <Waveform audio={audio} isPlaying={isPlaying} onPlay={onPlay} preview />
        </div>
        <div className="Stories-Audios__Audio--Details" onClick={handleAddAudio}>
          <div className="Audio-Header">
            <span className="Audio-Header__Name">{audio.name}</span>
            <PlainButton className={classnames("Audio-Header__Select")}>
              <Icon icon="ios-plus" />
              <div className="display">
                <Trans>Select audio</Trans>
              </div>
            </PlainButton>
          </div>
          <span className="Audio-Author">{audio.author}</span>
          <div className="chq-ffd-tags">
            <div className="chq-ffd-tags__child">
              {expanded ? (
                <>
                  {audio.tags.map(tag => (<Badge key={tag}>{tag}</Badge>))}
                  <div key="minus-option" className="ExpandOptions__minus-option">
                    <span
                      onClick={event => {
                        event.stopPropagation();
                        onExpand(false);
                      }}
                    >
                      <Icon icon="minus" />
                      {" "}
                      show less
                    </span>
                  </div>
                </>
              ) : (
                <>
                  {audio.tags.map((tag, index) => (
                    (index < numberOfTagsToshow) && (<Badge key={tag}>{tag}</Badge>)))}
                  {audio.tags.length > numberOfTagsToshow && (
                    <div key="plus-option" className="ExpandOptions__plus-option">
                      <span
                        onClick={event => {
                          event.stopPropagation();
                          onExpand(true);
                        }}
                      >
                        <Icon icon="plus" />
                        {" "}
                        {audio.tags.length - numberOfTagsToshow}
                      </span>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <hr />
    </>
  );
};

export default AudioOption;
